import { z } from 'zod';

// MongoDB ObjectId pattern
export const ObjectIdPattern = /^[0-9a-fA-F]{24}$/;

// Base ObjectId schema
export const ObjectIdSchema = z.string().regex(ObjectIdPattern, 'Invalid ObjectId format');

// Generic reference type that can be either string ID or populated object
export type PopulatedReference<T> = string | (T & { _id: string });

// Base timestamps interface
export interface BaseTimestamps {
  createdAt: Date;
  updatedAt: Date;
}

export interface IndexDefinition {
  fields: { [key: string]: 1 | -1 };
  options?: { unique?: boolean; sparse?: boolean; name?: string };
}

export interface createIndex {
  collectionName: string;
  index: IndexDefinition;
}

// Soft delete interface
export interface SoftDelete {
  deletedAt?: Date;
  isDeleted: boolean;
}

// Base document interface
export interface BaseDocument extends BaseTimestamps {
  _id: string;
}

// Base document with soft delete
export interface BaseSoftDeleteDocument extends BaseDocument, SoftDelete {}

// Common status types
export type UserStatus = 'active' | 'inactive' | 'suspended' | 'pending';
export type StudentStatus = 'active' | 'inactive' | 'graduated' | 'transferred';
export type ClassLevel = 'JSS1' | 'JSS2' | 'JSS3' | 'SS1' | 'SS2' | 'SS3';

// Validation schemas for common types
export const UserStatusSchema = z.enum(['active', 'inactive', 'suspended', 'pending']);
export const StudentStatusSchema = z.enum(['active', 'inactive', 'graduated', 'transferred']);
export const ClassLevelSchema = z.enum(['JSS1', 'JSS2', 'JSS3', 'SS1', 'SS2', 'SS3']);

// Base schemas
export const BaseTimestampsSchema = z.object({
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const SoftDeleteSchema = z.object({
  deletedAt: z.date().optional(),
  isDeleted: z.boolean().default(false),
});

export const BaseDocumentSchema = BaseTimestampsSchema.extend({
  _id: ObjectIdSchema,
});

export const BaseSoftDeleteDocumentSchema = BaseDocumentSchema.merge(SoftDeleteSchema);